<script setup>
import FormFieldSelect from '@/components/FormFieldSelect.vue'
import FormFieldError from '@/components/FormFieldError.vue'
import FormFieldValueTypeInput from '@/components/FormFieldValueTypeInput.vue'

const emit = defineEmits(['click:remove'])

defineProps({
  prefixLabel: {
    type: String,
    default: null
  },
  nestedItemOptions: {
    type: Array,
    default: () => []
  },
  operatorOptions: {
    type: Array,
    default: () => []
  },
  valueType: {
    type: String,
    default: null
  },
  nestedItemLabel: {
    type: String,
    default: 'Item'
  },
  nestedItemFieldModel: {
    type: Object,
    required: true
  },
  operatorFieldModel: {
    type: Object,
    default: null
  },
  valueFieldModel: {
    type: Object,
    required: true
  },
  disabled: {
    type: Boolean,
    default: false
  },
  showRemoveButton: {
    type: Boolean,
    default: false
  }
})
</script>

<template>
  <div class="card rounded">
    <div class="card-body row">
      <div
        class="d-flex align-items-center justify-content-start gap-3"
        :class="{'col-4': operatorFieldModel, 'col-6': !operatorFieldModel }"
      >
        <span v-if="prefixLabel" class="d-flex align-items-center justify-content-center">{{ prefixLabel }}</span>
        <div class="flex-fill">
          <FormFieldSelect
            class="form-select"
            :fieldModel="nestedItemFieldModel"
            :disabled="disabled"
            @change="() => {
              if (operatorFieldModel) {
                // eslint-disable-next-line
                operatorFieldModel.inputValue = null
              }
              // eslint-disable-next-line
              valueFieldModel.inputValue = null
            }"
          >
            <option :value="null">{{ `Select ${nestedItemLabel}` }}</option>
            <option v-for="(nestedItem, index) in nestedItemOptions" :key="index" :value="nestedItem">
              {{ nestedItem.name }}
            </option>
          </FormFieldSelect>
          <FormFieldError :fieldModel="nestedItemFieldModel" />
        </div>
      </div>
      <div
        class="col-4 d-flex align-items-center justify-content-start"
        v-if="operatorFieldModel"
      >
        <div class="flex-fill">
          <FormFieldSelect
            class="form-select"
            :fieldModel="operatorFieldModel"
            :disabled="disabled"
            @change="() => {
              // eslint-disable-next-line
              valueFieldModel.inputValue = null
            }"
          >
            <option :value="null">Select Operator</option>
            <option v-for="(operatorOption, index) in operatorOptions" :key="index" :value="operatorOption">
              {{ operatorOption.name }}
            </option>
          </FormFieldSelect>
          <FormFieldError :fieldModel="operatorFieldModel" />
        </div>
      </div>
      <div
        class="col-4 d-flex align-items-center justify-content-start"
        :class="{'col-4': operatorFieldModel, 'col-6': !operatorFieldModel }"
      >
        <span v-if="!operatorFieldModel" class="d-flex align-items-center justify-content-center pe-4">is</span>
        <div class="flex-fill">
          <FormFieldValueTypeInput
            :valueType="valueType"
            :fieldModel="valueFieldModel"
            :disabled="disabled"
          />
          <FormFieldError :fieldModel="valueFieldModel" />
        </div>
      </div>
      <div
        v-if="showRemoveButton"
        type="button"
        class="btn-remove"
        @click="emit('click:remove')"
        :disabled="disabled"
      >
        <BootstrapIcon name="bs-icon-x-lg" />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.btn-remove {
  position: absolute;
  top: 8px;
  right: 16px;
  min-width: 15px;
  max-width: 15px;
  cursor: pointer;
}
</style>
